import React from 'react';
const LayoutContext = React.createContext({
    isMobile: false,
});
export default LayoutContext;
